import * as HTTP_CODES from '../constants/http.codes';
import { forbiddenAction } from './error.handling';
import { ROOT_PATH } from '../constants/routes';
import { push } from 'react-router-redux';

export async function apiActionCreator(dispatch, request, success, actions = {}) {
    const response = await request();
    const errorDispatch = () => {
        const customErrorAction = actions.allErrors || actions[response.status];
        if (customErrorAction) {
            customErrorAction(response.json);
        } else {
            dispatch({
                type: HTTP_CODES.CODE_ACTIONS[response.status],
                json: response.json
            });
        }
    };
    switch (response && response.status) {
        case HTTP_CODES.OK_CODE:
        case HTTP_CODES.CREATED_CODE:
            return success(response.json);
        case HTTP_CODES.BAD_REQUEST_CODE:
        case HTTP_CODES.NOT_FOUND_CODE:
        case HTTP_CODES.SERVICE_UNAVAILABLE_CODE:
        case HTTP_CODES.INTERNAL_SERVER_ERROR_CODE:
        case HTTP_CODES.UNPROCESSABLE_ENTITY_CODE:
            return errorDispatch();
        case HTTP_CODES.GONE_CODE:
            const goneAction = actions[response.status];
            if (goneAction) {
                return goneAction(response.json);
            }
            break;
        case HTTP_CODES.UNAUTHORIZED_CODE:
        case HTTP_CODES.FORBIDDEN_CODE:
            const customErrorAction = actions.allErrors || actions[response.status];
            if (customErrorAction) {
                return customErrorAction(response.json);
            } else {
                dispatch(push(ROOT_PATH));
                return dispatch(forbiddenAction());
            }
        default:
            return success({});
    }
}

export const apiMultipleCalls = async (dispatch, apiCalls, done, index = 0, results = {}, collectAll = false) => {
    const _continue = response => {
        if (collectAll) {
            results[index] = response;
        } else {
            results = Object.assign(results, response);
        }
        if (apiCalls[index + 1]) {
            apiMultipleCalls(dispatch, apiCalls, done, index + 1, results, collectAll);
        } else {
            done(results);
        }
    };
    if (apiCalls.length) {
        await apiActionCreator(dispatch, apiCalls[index], _continue, {
            400: _continue
        });
    } else {
        done({});
    }
};



// WEBPACK FOOTER //
// ./src/actions/helpers.js